// extracted by mini-css-extract-plugin
export default {"background":"wMnGl","item":"P8Nx1","border":"_3wGLU","skeleton":"_3AsG3","checkMark":"_1CdqT"};